module.exports = __webpack_public_path__ + "static/media/hr.96a3b298.png";